/**
 * Loading skeleton shared by the "More" destinations so every page shows the
 * same shape while its first request is in flight.
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './more.css';

interface MoreLoadingProps {
  /** `list` mimics people/leaderboard rows, `card` a block of settings copy. */
  variant?: 'list' | 'card';
  count?: number;
}

export function MoreLoading({ variant = 'list', count = 4 }: MoreLoadingProps) {
  if (variant === 'card') {
    return (
      <SkeletonGroup className="more-card">
        <Skeleton className="more-skeleton__line more-skeleton__line--title" />
        {skeletonKeys(count).map(key => (
          <Skeleton className="more-skeleton__line" key={key} />
        ))}
      </SkeletonGroup>
    );
  }

  return (
    <SkeletonGroup className="more-card">
      {skeletonKeys(count).map(key => (
        <div className="more-skeleton__row" key={key} aria-hidden>
          <Skeleton shape="circle" className="more-skeleton__avatar" />
          <div className="more-skeleton__meta">
            <Skeleton className="more-skeleton__line more-skeleton__line--name" />
            <Skeleton className="more-skeleton__line more-skeleton__line--detail" />
          </div>
        </div>
      ))}
    </SkeletonGroup>
  );
}
